import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./scss/avis.scss";
import "@fortawesome/fontawesome-free/css/all.css";
import "react-perfect-scrollbar/dist/css/styles.css";

const container = document.getElementById("root");
const root = createRoot(container!);
window.React = React;
root.render(<App />);
